import React from 'react'
import { v4 as uuidv4 } from 'uuid';
import LinkImage from '../../../../components/LinkImage/index.js'

const SingleResponsibility = (props) =>{
    return (
        <>
            <li className="subpara-text">{props.element}</li>
        </>
    )
}

const SingleProjects = (props) =>{
    return(
        <>
        <div>
            <p className="para-text">{props.title}
                {props.startDate !== '' && ' | ' + props.startDate}
                {(props.startDate !== '' && props.endDate !== '') && ' - '}
                {props.endDate !== '' && props.endDate}
                {props.comment !== '' && ' | ' + props.comment}
                {props.link !== undefined && props.link !== null && props.link !== '' &&
                    <span> | Link <a target="new" href={props.link}>
                        &nbsp;<LinkImage />
                    </a></span>
                }
            </p>
            <ul type="disc">
                {
                    props.desc.map((element)=>{
                        return <SingleResponsibility key={uuidv4()} element={element}/>
                    })
                }
            </ul>
        </div>
        </>
    )
}


function Projects(props) {
    return (
        <>
            <section className="education">
                <p className="heading-text"> PROJECTS UNDERTAKEN </p>
                {
                    props.projects.map((element)=>{
                        return <SingleProjects key={uuidv4()} {...element}/>
                    })
                }
                <div>
                </div>
            </section>
        </>
    )
}

export default Projects
